export { default } from './ChangeOrientation.container';
